import { ConfigService } from '@/configServices';
import { AddCertificateDetails } from '@/model/certificateDetails/add-certificate-details';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-admin-view-certificate-list',
  templateUrl: './admin-view-certificate-list.component.html',
  styleUrl: './admin-view-certificate-list.component.scss'
})
export class AdminViewCertificateListComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  searchText: string = '';
  certificateDetails: AddCertificateDetails[] = [];

  constructor(private appService: AppService, private toastr: ToastrService,
    private spinner: NgxSpinnerService, private router: Router, private configService: ConfigService) {

  }

  ngOnInit(): void {
    this.getAllCertificateDetails();
  }


  getAllCertificateDetails() {
    this.spinner.show();
    this.appService.getAllCertificateDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.certificateDetails = data.sort((a, b) => b.id - a.id);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something Went Wrong,Please Try Again...")
      })
  }

  openUrl(id: string): void {
    const encryptedId = btoa(id.toString());
    this.router.navigate(['/certificate-view']);
    localStorage.setItem("certificateId", String(encryptedId))
  }
}
